import React from 'react';

export const Star: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M8.331 7.29a.98.98 0 0 1-.736.52l-6.258.89a.99.99 0 0 0-.557.275.927.927 0 0 0 .015 1.342l4.531 4.295c.23.218.335.53.28.837L4.54 21.513a.92.92 0 0 0 .099.602.995.995 0 0 0 1.322.396l5.587-2.859c.286-.146.629-.146.915 0l5.587 2.86c.191.097.409.13.621.096a.953.953 0 0 0 .801-1.095l-1.069-6.064a.93.93 0 0 1 .28-.837l4.533-4.295a.944.944 0 0 0 .284-.541c.078-.518-.292-1-.827-1.076l-6.258-.89a.978.978 0 0 1-.736-.52l-2.795-5.51a.968.968 0 0 0-.447-.433 1.003 1.003 0 0 0-.43-.097.983.983 0 0 0-.88.53L8.33 7.29z" />
  </svg>
);
